import { Col, Row, Table } from "antd";
import { useTranslation } from "react-i18next";
import { MdOpenInNew, MdOutlineDeleteOutline } from "react-icons/md";
import { useNavigate } from "react-router-dom";

import Pagination from "shared/components/Pagination";
import Status from "shared/components/Status";
import { NAME_SPACES } from "shared/locales/constants";
import { COLORS } from "shared/style/colors";
import { SCREENS } from "utils/constants";

function List({ data, count, setValues, skip, setOpenDetail }) {
  const navigate = useNavigate();
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.QUALIFIER);
  const LIST = t("LIST", { returnObjects: true });

  const columns = [
    {
      title: LIST.NAME,
      dataIndex: "name",
      render: (record) => <Status text={record} status="black" />,
    },
    {
      title: LIST.DESCRIPTION,
      dataIndex: "description",
      render: (record) => record || "-",
    },
    {
      title: LIST.ACTIONS,
      dataIndex: "id",
      align: "right",
      render: (id, row) => (
        <Row gutter={8} justify="end" align="center" wrap={false}>
          <Col
            onClick={() =>
              setOpenDetail({
                id,
                name: row.name,
                description: row.description,
                tag: row.tag,
                events: row.events || [],
              })
            }
          >
            <MdOpenInNew size={24} color={COLORS.C_PRIMARY} />
          </Col>
          <Col
            onClick={() =>
              navigate(`${SCREENS.PRIVATE.ADMIN.QUALIFIERS.DELETE.path}/${id}`)
            }
          >
            <MdOutlineDeleteOutline size={24} color={COLORS.C_DANGER} />
          </Col>
        </Row>
      ),
    },
  ];

  return (
    <>
      <Table
        dataSource={data}
        className="table__wrapper"
        columns={columns}
        rowKey={"id"}
        pagination={false}
        scroll={{ x: true }}
      />
      <Pagination count={count} setValues={setValues} skip={skip} />
    </>
  );
}

export default List;
